import { IUserProps } from "../../common/data/userDummyData";

export const checkUserRedirect = (
	userToken: string | null,
	userData: IUserProps | null
): string | null => {
	if (!userToken) return '/login';

	if (userData) {
		const missingFields: string[] = [];

		// Eksik alanları kontrol et
		['post_code', 'email', 'phone_number', 'firstname', 'lastname', 'identity_no', 'birth_date', 'company_name'].forEach(field => {
			if (!userData[field as keyof IUserProps]) missingFields.push(field);
		});

		// identity_verification özel kontrolü
		if (userData.identity_no && !userData.identity_verification) missingFields.push('identity_verification');

		if (missingFields.length > 0) {
			console.log('Eksik alanlar:', missingFields.join(', '));
			return '/profile/account';
		}
	}

	return null;
};
